( function( $ ) {
	'use strict';

	$( function() {
		const activeClass 			= 'is-active';
		const bodyActiveClass 		= 'site-offcanvas-active';
		const offcanvasActiveClass 	= 'site-offcanvas--is-active';
		
		const $offcanvas 	= $( '.js-site-offcanvas' );
		const $menuTrigger 	= $( '.js-site-offcanvas-trigger' );
		const $back 		= $( '.js-site-offcanvas-back' );
		const $close 		= $( '.js-site-offcanvas-close' );

		const $item 		= $( '.js-offcanvas-menu-item' );
		const $trigger 		= $( '.js-offcanvas-menu-trigger' );
		const $submenu 		= $( '.js-offcanvas-menu-submenu' );

		//---------------------------------------------------------------------------
		//	Handle active class
		//---------------------------------------------------------------------------

		$menuTrigger.on( 'click', function() {
			$( 'body' ).addClass( bodyActiveClass );
			$offcanvas.addClass( offcanvasActiveClass );
		} );

		$close.on( 'click', function() {
			$( 'body' ).removeClass( bodyActiveClass )
			$offcanvas.removeClass( offcanvasActiveClass );
		} );

		//---------------------------------------------------------------------------
		//	Navigation logic
		//---------------------------------------------------------------------------

		$back.removeClass( activeClass );

		$trigger.on( 'click', function( e ) {
			e.preventDefault();
			$( this ).parent().find( $submenu ).first().addClass( activeClass );
			$back.addClass( activeClass );
		} );

		$back.on( 'click', function() {
			$submenu.filter( `.${activeClass}` ).last().removeClass( activeClass );

			if ( $submenu.filter( `.${activeClass}` ).length === 0 ) {
				$back.removeClass( activeClass );
			}
		} );

		$( $submenu ).find( 'a' ).not( $trigger ).on( 'click', function() {
			$offcanvas.removeClass( offcanvasActiveClass );
		} );
	} );
} )( jQuery );
